import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'サービス', path: '/services' },
  { label: '制作実績', path: '/case-study' },
  { label: 'プロフィール', path: '/about' },
  { label: 'お問い合わせ', path: '/contact' },
];

const serviceList = ['WEBサイト制作', 'SNS運用代行', 'デジタルマーケティング'];

export default function Footer() {
  return (
    <footer className="bg-[#1C2B22] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10 mb-16">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10">
                <span className="text-white font-bold text-sm">G</span>
              </div>
              <span translate="no" className="font-bold text-xl tracking-widest">GRAINN</span>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              WEBサイト制作・SNS運用代行を通じ、<br />
              ビジネスのデジタル成長を支援します。
            </p>
            <div className="space-y-2 text-sm text-white/50">
              <p>〒553-0003</p>
              <p>大阪府大阪市福島区福島</p>
              <p className="mt-3">goto_sn@grain-n.com</p>
              <p>080-5353-0610</p>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs tracking-[0.2em] text-white/30 mb-5 uppercase">Navigation</p>
            <ul className="space-y-3">
              {navLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <p className="text-xs tracking-[0.2em] text-white/30 mb-5 uppercase">Services</p>
            <ul className="space-y-3">
              {serviceList.map((s) => (
                <li key={s}>
                  <span className="text-sm text-white/60">{s}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs tracking-widest">
            © {new Date().getFullYear()} <span translate="no">GRAINN</span>. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">
              プライバシーポリシー
            </Link>
            <Link to="/terms" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">
              利用規約
            </Link>
          </div>
        </div>
      </div>

      {/* Large Type */}
      <div className="border-t border-white/5 px-6 md:px-10 py-8 overflow-hidden">
        <p translate="no" className="text-[8vw] md:text-[7vw] font-black tracking-tighter text-white/5 select-none whitespace-nowrap">
          GRAINN
        </p>
      </div>
    </footer>
  );
}
